import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import HardwarePage from './Pages/HardwarePage';
import HomePage from './Pages/HomePage';
import { Box } from '@mui/material';
import AboutUsPage from './Pages/AboutUsPage';
import FurniturePage from './Pages/FurniturePage';
import Footer from './Components/Footer';

export default function Main() {
    return (
        <React.StrictMode>
            <BrowserRouter>
                <Box sx={{ flexDirection: 'column', overflow: 'hidden', flex: 1 }}>
                    <App />
                    <Box className='ContentContainer' sx={{ minWidth: '100%', maxWidth: '100%', minHeight: '100%', marginTop: '40px', padding: '20px', alignItems: 'center', justifyContent: 'center' }}>
                        <Routes>
                            <Route path={'/'} element={<HomePage />} />
                            <Route path={'/it-hardware'} element={<HardwarePage includeDetails={true} />} />
                            <Route path={'/furniture'} element={<FurniturePage includeDetails={true} />} />
                            <Route path={'/about'} element={<AboutUsPage />} />
                        </Routes>
                    </Box>
                </Box>
            </BrowserRouter>
            <Footer />
        </React.StrictMode>
    )
}
